export default __webpack_public_path__ + "static/media/banner3.0e3f7041.png";